import Vue from 'vue';
import Vuex from 'vuex';

import carts from './carts/index';
import user from './user/index';

import { fireApp, fireUi } from './../firebase.config';


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    carts,
    user,
  },
  state: {
    fireApp,
    fireUi,
  },
});
